import { render, staticRenderFns } from "./YouTubeCarousel.vue?vue&type=template&id=46d04385&scoped=true"
import script from "./YouTubeCarousel.vue?vue&type=script&lang=js"
export * from "./YouTubeCarousel.vue?vue&type=script&lang=js"
import style0 from "./YouTubeCarousel.vue?vue&type=style&index=0&id=46d04385&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d04385",
  null
  
)

export default component.exports